import { createSlice } from '@reduxjs/toolkit';
import ApiClientConnector from 'src/api/ApiClientConnector';

const initialState = {
    services: [],
    serviceImages: [],
    isDetailView: false,
    isManageView: false,
    selectedServiceId: null,
    isEditView: false,
    selectedItem: null
};
export const ManageServiceSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        getServiceResultList: (state, action) => {
            state.services = action.payload;
        },
        getServiceImages: (state, action) => {
            state.serviceImages = action.payload;
        },
        changeSelectedItemId: (state, action) => {
            state.selectedServiceId = action.payload;
        },
        changeDetailView: (state, action) => {
            state.isDetailView = action.payload;
        },
        changeManageView: (state, action) => {
            state.isManageView = action.payload;
        },
        changeEditView: (state, action) => {
            state.isEditView = action.payload;
        },
        changeSelectedItem: (state, action) => {
            state.selectedItem = action.payload;
        },
        updateServiceContentDescription: (state, action) => {
            if (state.selectedItem) {
                state.selectedItem.Content = {
                    ...state.selectedItem.Content,
                    Description: action.payload
                };
            }
        }
    },
});

export const {
    getServiceResultList,
    changeSelectedItemId,
    changeDetailView,
    changeManageView,
    changeEditView,
    changeSelectedItem,
    updateServiceContentDescription
} = ManageServiceSlice.actions;

export const fetchServices = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.post(criteria);
    const serviceArray = result.Results || [];
    dispatch(getServiceResultList(serviceArray));
    return result;
};

export const fetchServiceImages = (instance, accounts, serviceId) => async () => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.getServiceImages(serviceId);
    return result;
};

export const fetchServiceList = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.getServices(criteria);
    dispatch(getServiceResultList(result));
    return result;
};

export const fetchSelectedService = (instance, accounts, serviceId) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.getServiceById(serviceId);
    dispatch(changeSelectedItem(result));
    return result;
};

export const updateServiceDescription = (instance, accounts, serviceId, description) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.services.updateServiceDescription(serviceId, description);
    return dispatch(updateServiceContentDescription(result?.Description));
};


export default ManageServiceSlice.reducer;